import { Badge } from '@/components/ui/badge';
import {
  ClauseStatus,
  ContractClauseStatus,
  ContractStatus,
} from '@/types/StatusType';

export const NegotiationStatusBadge = (status?: ContractStatus) => {
  switch (status) {
    case 'finalized':
      return (
        <Badge
          variant="outline"
          className="bg-green-500 text-white hover:bg-green-600 hover:text-white cursor-pointer"
        >
          Finalized
        </Badge>
      );
    case 'draft':
      return (
        <Badge variant="outline" className="bg-blue-100 text-blue-800">
          Draft
        </Badge>
      );
    case 'under_review':
      return (
        <Badge variant="outline" className="bg-yellow-600 text-white">
          Under Review
        </Badge>
      );
    case 'suggested':
      return (
        <Badge variant="outline" className="bg-orange-100 text-orange-800">
          Suggested
        </Badge>
      );
    case 'rejected':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800">
          Rejected
        </Badge>
      );
    case 'counter_proposed':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800">
          Counter Proposed
        </Badge>
      );
    case 'contingent':
      return (
        <Badge variant="outline" className="bg-yellow-100 text-yellow-800">
          Contingent
        </Badge>
      );
    case 'take_it_or_leave_it':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800">
          Take it or Leave it
        </Badge>
      );
    case 'agreeable':
      return (
        <Badge variant="outline" className="bg-green-100 text-green-800">
          Agreeable
        </Badge>
      );
    case 'reopened':
      return (
        <Badge
          variant="outline"
          className="capitalize bg-yellow-100 text-[#f7941D]'"
        >
          Reopened
        </Badge>
      );
    case 'voided':
      return (
        <Badge
          variant="outline"
          className="bg-yellow-100 text-yellow-800 border-yellow-400"
        >
          Voided
        </Badge>
      );
    case 'expired':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800">
          Expired
        </Badge>
      );
    default:
      return null;
  }
};

export const ClauseStatusBadge = (status?: ContractClauseStatus) => {
  switch (status) {
    case 'draft':
      return (
        <Badge variant="outline" className="bg-blue-100 text-blue-800">
          Draft
        </Badge>
      );
    case 'under_review':
      return (
        <Badge variant="outline" className="bg-yellow-600 text-white">
          Under Review
        </Badge>
      );
    case 'agreeable':
      return (
        <Badge variant="outline" className="bg-green-100 text-green-800">
          Agreeable
        </Badge>
      );
    case 'suggested':
      return (
        <Badge variant="outline" className="bg-orange-100 text-orange-800">
          Suggested
        </Badge>
      );
    case 'rejected':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800">
          Rejected
        </Badge>
      );
    case 'counter_proposed':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800">
          Counter Proposed
        </Badge>
      );
    case 'contingent':
      return (
        <Badge variant="outline" className="bg-yellow-100 text-yellow-800">
          Contingent
        </Badge>
      );
    case 'take_it_or_leave_it':
      return (
        <Badge variant="outline" className="bg-red-100 text-red-800">
          Take it or Leave it
        </Badge>
      );
    default:
      return null;
  }
};
